import Assignment from './AssignmentPage.container';

export default Assignment;
